import React, { useEffect } from 'react';
import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css";
import './RichTextArea.css';

function RichTextArea(props) {
  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ align: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ color: [] }, { background: [] }],
    ],
  };

  const { quill, quillRef } = useQuill({ modules });

  useEffect(() => {
    if (quill) {
      quill.clipboard.dangerouslyPasteHTML(props.value); // Set the API data into the editor
    }
  }, [quill]);

  useEffect(() => {
    if (quill) {
      quill.on('text-change', (delta) => {
        props.onChange(quill.getSemanticHTML())
      })
    }
  }, [quill])

  return (
    <div className="rich-text-area" onClick={props.onClick}>
      <div ref={quillRef} />
    </div>
  );
};


export default RichTextArea;